import { useSelector } from 'react-redux';
import { selectFeatureFlags } from '../../../../../CommonSelectors/CommonAreaSelector';
import { isOptedIn } from '../../../../../CommonUtils/isOptedIn';
import { useIsCurrentPlanSelected } from '../../../hooks/useIsCurrentPlanSelected';

export const useAreWhatIfsEnabled = () => {
  const { isCurrentPlanSelected } = useIsCurrentPlanSelected();

  const hasAccessToWhatIfs = isOptedIn('Calibration');

  const featureFlags: { name: string; enabled: boolean }[] = useSelector(selectFeatureFlags);

  return (
    !isCurrentPlanSelected &&
    hasAccessToWhatIfs &&
    featureFlags.some(
      featureFlag => featureFlag.name === 'EnableAssetBucketingWhatIfs' && featureFlag.enabled,
    )
  );
};
